import React from "react"
import Slider, { Settings as SlickSettings } from "react-slick"
import { TwitterTweetEmbed } from "react-twitter-embed"

interface Props {
  tweets: string[]
}

export const TwitterCards: React.FC<Props> = ({ tweets }) => {
  // const tweets = [...props.tweets, "20", "1242435999189385216"]

  const sliderSettings: SlickSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    useTransform: true,
    cssEase: "ease-in",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false,
        },
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  if (!tweets || !tweets.length) {
    return null
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onTweetLoaded = (twitterWidgetElement: any) => {
    if (
      twitterWidgetElement &&
      typeof twitterWidgetElement === "object" &&
      twitterWidgetElement.shadowRoot &&
      typeof twitterWidgetElement.shadowRoot === "object"
    ) {
      const shadowElement = twitterWidgetElement.shadowRoot
      shadowElement.querySelector(".Tweet-text").style.height = "200px"
      shadowElement.querySelector(".Tweet-text").style.overflow = "hidden"
      shadowElement.querySelector(".EmbeddedTweet").style.borderWidth = "0"
    }
  }

  return (
    <>
      <div>
        <Slider
          {...sliderSettings}
          key={`${Math.floor(Math.random() * 100)}`}
          className="twitter-slider"
        >
          {tweets.map(tweet => (
            <div key={tweet} className="twitter-card">
              <TwitterTweetEmbed tweetId={tweet} onLoad={onTweetLoaded} />
            </div>
          ))}
        </Slider>
      </div>
    </>
  )
}
